import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import {
  GLOSSARY_DEFAULTS,
  GlossarySettings,
} from 'clerk_common/types/glossary';
import { useMemo } from 'react';

export type ResolvedGlossary = Required<GlossarySettings>;

export function useGlossary(): ResolvedGlossary {
  const { me } = useMeContext();
  const glossary = me?.organizationsDetails[0]?.settings?.glossary;

  return useMemo(
    () => ({
      customerCode: glossary?.customerCode || GLOSSARY_DEFAULTS.customerCode,
      tms: glossary?.tms || GLOSSARY_DEFAULTS.tms,
    }),
    [glossary?.customerCode, glossary?.tms]
  );
}
